export default "__VITE_PUBLIC_ASSET__a0aacd81__"